export default "__VITE_ASSET__dv3GZzG8__"